module.exports = __webpack_public_path__ + "fonts/nucleo-icons.861720fa.woff";